import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

// Função para buscar as reservas

export const buscarReservaPeriodo = async (
  periodoUsuarioId: number | null | undefined
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva/periodoUsuario/${periodoUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response) {
        return response.data;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  }
};
